// Polyfill de setImmediate: no Web, react-native-web não expõe esse global
// (só existe via runtime nativo do React Native), mas react-native-gesture-handler
// e react-native-reanimated dependem dele. Sem isso, qualquer tela que monte um
// BottomSheet/Modalize quebra com "setImmediate is not defined" e derruba o app
// inteiro (sem Error Boundary). No-op em nativo, onde o global já existe.
import 'setimmediate';

import React from 'react';
import { StatusBar } from 'react-native';
import { ThemeProvider, useTheme } from 'react-native-paper';

import Routes from './src/navigation/routes';

export default function App() {
  const currentTheme = useTheme();

  return (
    <ThemeProvider theme={currentTheme}>
      <StatusBar barStyle="dark-content" backgroundColor="transparent" translucent />
      <Routes />
    </ThemeProvider>
  );
}